import { useEffect, useState } from 'react';
import { isInWuKongApp } from '@/utils/fbPixel';
import { isMiniProgram } from '@/utils/wechat';

const useShouldInjectFbPixel = () => {
  const [shouldInject, setShouldInject] = useState(false);

  useEffect(() => {
    if (!isMiniProgram() && !isInWuKongApp()) {
      setShouldInject(true);
    }
  }, []);

  return shouldInject;
};

export default useShouldInjectFbPixel;
